export default {
  regionAlreadyExists: (state) => (name, id) => {
    return state.regions.some(region => region.name === name && region.id !== id);
  }
}
